import DataSource from './DataSource';
import DataModel from './DataModel';

const DataAttributes = ['id', 'name', 'starts_at', 'closed', 'description', 
  'invited_expert_ids', 'experts_breeds', 'experts_rings'];
const Defaults = () => ({
  id: '',
  name: '',
  starts_at: '',
  closed: false,
  dogs_count: 0,
  description: '',
  invited_experts: [],
});

export default class Show extends DataModel {
  static Defaults = Defaults;
  static DataAttributes = DataAttributes;
  static resource = DataSource.getSource('shows', 'shows{/:id}{/:action}.json', 'show');

  static start_dates() {
    return this.query({}, 'shows/start_dates').then(dates => {
      return dates.map(date => new Date(date));
    });
  }
  
  static getDogs(id, params={}) {
    return this.resource.get(id, {...params, action: 'dogs'}).then((data) => {
      return data;
    })
  }
  
  static getCertificates(id) {
    return this.resource.get(id, {action: 'certificates'}).then((data) => {
      return data;
    })
  }

  static getDiplomas(id) {
    return this.resource.get(id, {action: 'diplomas'}).then((data) => {
      return data;
    })
  }
  
  static withBreeds(id) {
    return this.resource.get(id, {action: 'breeds'}).then((data) => {
      return data;
    })
  }

  static withRings(id) {
    return this.resource.get(id, {action: 'rings'}).then((data) => {
      return new Show(data);
    })
  }
  static getCatalogRecipients(id) {
    return this.resource.get(id, {action: 'catalog_recipients'}).then((data) => {
      return data;
    })
  }
  
  constructor(data) {
    super(data);
    this.updateFrom({...this.constructor.Defaults(), ...data});
    if (this.starts_at) {
      this.starts_at = new Date(Date.parse(this.starts_at));
    } else {
      this.starts_at = new Date();
    }
  }

  numberDogs() {
    const patch = {id: this.id, action: 'number_dogs'};
    return this.constructor.resource.update(patch);
  }

  sendTickets() {
    const patch = {id: this.id, action: 'send_tickets'};
    return this.constructor.resource.update(patch); 
  }

  resetTicketSent() {
    const patch = {id: this.id, action: 'reset_ticket_sent'};
    return this.constructor.resource.update(patch); 
  }

}

